module.exports = __webpack_public_path__ + "img/resumes.2d2bcb10.svg";